import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ProductInternal from '../../../Container/Dashboard/ProductInternal';
import { usePatient } from '../../../Contexts/PatientContext';

const ProductDetails = () => {
	const location = useLocation();
	const { state } = location;
	const { updatePatient } = usePatient();

	useEffect(() => {
		if (state && state.data) {
			updatePatient(state.data);
		}
	}, [state]);

	return (
		<ProductInternal />
	)
}

export default ProductDetails;
